import React from "react";

import { EmailPrivacy } from "src/components/EmailPrivacy";
import { ArticlePageContent } from "src/components/layout/ArticlePage";
import { DefaultPageLayout } from "src/components/layout/DefaultPageLayout";
import { HeaderTitlePageSection } from "src/components/layout/PageSection";

const NameAndPrivacyUrl = [
  ["Auth0", "https://auth0.com/privacy"],
  ["Cloudinary", "https://cloudinary.com/privacy"],
  ["Constructor.io", "https://constructor.io/privacy-policy"],
  ["Facebook", "https://www.facebook.com/privacy/explanation"],
  ["Hotjar", "https://www.hotjar.com/legal/policies/privacy/"],
  [
    "Google Analytics and Demographic Reporting",
    "https://policies.google.com/technologies/partner-sites",
  ],
  ["Heroku", "https://www.heroku.com/policy/"],
  ["Network for Good", "https://www.networkforgood.com/about/privacy/"],
  ["New Relic", "https://newrelic.com/termsandconditions/privacy"],
  ["Plaid", "https://plaid.com/legal/"],
  ["Salesforce", "https://www.salesforce.com/company/privacy/"],
  ["Sentry", "https://sentry.io/privacy/"],
  ["Statsig", "https://statsig.com/privacy"],
  ["Stripe", "https://stripe.com/privacy"],
  ["Sumo Logic", "https://www.sumologic.com/privacy-statement/"],
  ["Zendesk", "https://www.zendesk.com/company/privacy-and-data-protection/"],
];

const Vendors: React.FCC = () => {
  return (
    <DefaultPageLayout
      pageTitle="Vendors and Third-Party Services We Work With"
      metas={{
        "og:description":
          "Every.org works with third-party services to provide many of the features or functionality on our site.",
      }}
      headerContent={
        <HeaderTitlePageSection>
          <h1>Vendors</h1>
        </HeaderTitlePageSection>
      }
    >
      <ArticlePageContent>
        <p>
          Every.org works with third-party services to provide many of the
          features or functionality on our Site using data about your use of our
          platforms as well as other sites. Below is a list of these partners
          with links to more information about their use of your data. This list
          may be updated from time to time as we add or remove partners from our
          platforms.
        </p>
        <p>
          If you have any questions about any of our third-party partners, you
          may contact us at: <EmailPrivacy />.
        </p>
        <ul>
          {NameAndPrivacyUrl.map(([name, url], i) => (
            <li key={i}>
              <a href={url}>{name}</a>
            </li>
          ))}
        </ul>
      </ArticlePageContent>
    </DefaultPageLayout>
  );
};

// Use default export to support React Lazy Loading.
export default Vendors;
